// extracted by mini-css-extract-plugin
module.exports = {"content":"Content-module--content--3eFY-"};